<template>
  <TsContent model="brands" :path="computeUrlPathAttribute()"/>
</template>
<script setup lang="ts">

const TsContent = defineAsyncComponent(
    () => import('~/components/builder/TsContent.vue')
);

const route = useRoute();


const computeUrlPathAttribute = () => {
  return route.path.replace(/^\/[a-z]{2}-[A-Z]{2}/, "");
};


</script> 
